import { h, render } from 'preact';
import { Provider } from 'react-redux';
import store from 'common/store/store';
import HotelListing from './hotel-listing';

export default class HotelListingContainer {
    constructor(container) {
        this.container = container;

        render( (
            <Provider store={store}>
                <HotelListing data={this.container.dataset} />
            </Provider>
        ), this.container)
        
    }

    // Called when the widget is removed from the page
    destroy() {
        render( null, this.container );
    }
}